import React from 'react'
import styled from 'styled-components'
import { Select } from 'antd'

const { Option } = Select

type Props = {
  label: string
  value: string
  placeholder?: string
  options: Array<{ label: string; value: string | number }>
  error?: string
  onChange: (value: string) => void
  onBlur?: () => void
}

const SimpleSelectField = ({
  label,
  value,
  placeholder,
  onChange,
  onBlur,
  options,
  error,
}: Props) => {
  return (
    <FieldWrapper>
      <label>{label}</label>
      <Select
        placeholder={placeholder}
        value={value || undefined}
        onChange={onChange}
        onBlur={onBlur}
        size="large"
        className={error ? 'error' : ''}
      >
        {options.map((item) => (
          <Option key={item.value} value={item.value}>
            {item.label}
          </Option>
        ))}
      </Select>

      {error && <span className="error-text">{error}</span>}
    </FieldWrapper>
  )
}

export default SimpleSelectField

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    font-weight: 800;
    font-size: 16px;
  }

  .ant-select {
    width: 100%;
  }

  .ant-select-selector {
    border: 1px solid #c6b98c !important;
    border-radius: 10px !important;
    padding: 10px 14px;
    background-color: white;
    font-size: 16px;
  }

  .ant-select.error .ant-select-selector {
    border-color: #ff4d4f !important;
  }

  .error-text {
    font-size: 14px;
    color: #ff4d4f;
    line-height: 18px;
    padding: 0;
    margin: 0;
  }
`
